import React, { useEffect, useState, useRef } from 'react'
import { Icon, Toast } from 'antd-mobile'
import { useRequest } from 'ahooks'
import { getFeedbackList, addComment } from '@feedback/services/index'
import List from './components/List'
import CommonModal from '@feedback/components/CommonModal'
import RatingFiveModal from './components/RatingFiveModal'
import { appUploadAddress } from '@feedback/utils/url'
import { getUA } from '@/utils/utils'
import { getTextByKey, reportFn } from '@feedback/utils/util'
import qs from 'qs'
import './App.scss'
interface Props {
  form: any
  history: {
    location: {
      search: string
    }
    replace: any
  }
  match: any
}
const LIMIT = 20 // 每页的数据量
//工单，反馈列表
const App: React.FC<Props> = ({ history }) => {
  const [isShowModal, toggleShowModal] = useState<boolean>(false) // 提交评论后（）
  const [isShowRateModal, toggleShowRateModal] = useState<boolean>(false) // 五星好评引导弹窗
  const [page, setPage] = useState<number>(1) // 当前分页页码
  const [count, setCount] = useState<number>(-1) // 当前总数
  const [list, setList] = useState<any[]>([]) // 列表
  const [curCommFbId, setCurCommFbId] = useState<string>('')
  const scrollEl = useRef<HTMLDivElement>(null)
  const { feedback_id: curFeedbackId } = qs.parse(
    history.location.search.split('?')[1]
  )
  const scrollEvent = () => {
    if (!scrollEl || loading || (count !== -1 && count <= list.length)) {
      return
    }
    if (scrollEl.current) {
      const { scrollTop, clientHeight, scrollHeight } = scrollEl.current
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        getList() // page: page, limit: LIMIT
      }
    }
  }
  // 清除list 数据
  const clearList = () => {
    setPage(1)
    setCount(-1)
    setList([])
  }
  // 提交评论
  const { loading: loadingComment, run: submitComment } = useRequest(
    addComment,
    {
      manual: true,
      onSuccess: (result, params) => {
        if (params.length > 0 && params[0]?.feedback_id) {
          setCurCommFbId(params[0].feedback_id)
        }

        const { code, message } = result
        if (code === 0) {
          clearList()
          if (params[0].star === 5) {
            toggleShowRateModal(true)
          } else {
            toggleShowModal(true)
          }
          setTimeout(() => {
            getList() //page: 1, limit: LIMIT
          }, 100)
        } else {
          Toast.info(message, 2)
        }
      }
    }
  )
  // 加载列表
  const { loading, run: getList } = useRequest(getFeedbackList, {
    manual: true,
    onSuccess: (result) => {
      const { data, code } = result
      if (code === 0) {
        // setPage((page) => page + 1)
        // count !== data.count && setCount(data.count)
        data.list.length > 0 && setList((curList) => [...curList, ...data.list])
      }
    }
  })
  const closeShowModal = () => {
    toggleShowModal(false)
  }
  const closeShowRateModal = () => {
    toggleShowRateModal(false)
  }
  const confirmModal = () => {
    closeShowModal()
    setTimeout(() => {
      history.replace('/v1/ticketList')
    }, 0)
  }
  const confirmShowRateModal = () => {
    reportFn({ parm1: 4, parm2: 3, parm6: curCommFbId })
    closeShowRateModal()
    const UA = getUA()
    if (UA?.ios) {
      appUploadAddress?.cm1001?.ios && window.open(appUploadAddress.cm1001.ios)
    } else {
      appUploadAddress?.cm1001?.ios &&
        window.open(appUploadAddress.cm1001.android)
    }
  }
  useEffect(() => {
    getList() //page: 1, limit: LIMIT
  }, [getList])

  useEffect(() => {
    document.title = getTextByKey('feedback history')
  }, [])
  return (
    <div className='p-ticket-list' ref={scrollEl}>
      {/*onScroll={scrollEvent}*/}
      <div className='label'>{getTextByKey('feedback history')}</div>
      <div className='listOut'>
        <List
          listData={list}
          curFeedbackId={curFeedbackId}
          submitComment={submitComment}
        />
      </div>
      <div className='header-loading'>
        {loading && <Icon type={'loading'} size={'xs'} />}
        {/* {count !== -1 && count <= list.length && <div className='loading-str'>not more ~</div>}submit modal tip */}
      </div>
      {isShowModal && (
        <CommonModal
          title={getTextByKey('notification')}
          desc={getTextByKey('thank rate')}
          tip=''
          confirmText={getTextByKey('confirm')}
          confirmFun={confirmModal}
          closeFun={closeShowModal}
        />
      )}
      {isShowRateModal && (
        <RatingFiveModal
          closeFun={closeShowRateModal}
          desc={getTextByKey('satisfaction modal tip')}
          confirmText={getTextByKey('confirm')}
          confirmFun={confirmShowRateModal}
        />
      )}
    </div>
    // Working hours:  09:30~18:00
  )
}

export default App
